const FounderViewCard = ({ element, handleOpenDrawer }) => {
    return (
        <div
            className={`bg-white  rounded-lg   flex flex-col items-center justify-center  w-full border  border-[#949494]/50  relative  `}
        >
           
             <div className="h-[16vh] bg-[#E2E2E2] w-full rounded-t-lg"></div>
        
        {/* Bottom half */}
        <div className="flex flex-col items-center pt-[6vh] pb-[4vh] w-full h-[18vh] ">
         <div className="text-[2.8vh] text-center  pb-4 font-inter font-[400] pb-[2vh]">{element.INSTITUTE_LEADER_DESIGNATION}</div>
           <button
                onClick={() => handleOpenDrawer()}
                className="w-[70%] py-2 bg-[#fff]  text-[#374AF2] rounded-lg text-[2vh] font-medium border border-[#374AF2]"
                style={{ color: "#374AF2" }}
                type="button"
            >
                Add Details
            </button> 
        </div>

        {/* Circle */}
        <div className="absolute top-[5vh]   w-[15vh] h-[15vh] bg-white rounded-full border-[0.5vh] border-[#E2E2E2] flex items-center justify-center">
           <div className="w-[14vh] h-[14vh] bg-[#fff] rounded-full flex items-center justify-center">
                    <img src="/images/UserPlus.svg" alt="User Plus" className="w-[9vh] h-[9vh]" />
                </div>
        </div>

            
        </div>

        
    );
}

export default FounderViewCard;